"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterItems = filterItems;
exports.getAllItemValues = exports.getAllItemProps = void 0;
exports.getFlattenItems = getFlattenItems;
exports.labelFor = exports.isMenuItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _compact = _interopRequireDefault(require("lodash/fp/compact"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _flatten = _interopRequireDefault(require("lodash/fp/flatten"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _prop2 = _interopRequireDefault(require("lodash/fp/prop"));
var _propEq = _interopRequireDefault(require("lodash/fp/propEq"));
var _find = _interopRequireDefault(require("lodash/fp/find"));
var _eq = _interopRequireDefault(require("lodash/fp/eq"));
var _escapeRegExp = _interopRequireDefault(require("lodash/fp/escapeRegExp"));
var _componentUtils = require("@active/react-utils/componentUtils");
var _MenuItem = _interopRequireDefault(require("../MenuItem"));
var _MenuItemList = _interopRequireDefault(require("../MenuItemList"));
var _MenuItemGroup = _interopRequireDefault(require("../MenuItemGroup"));
var _MenuSuggestionItem = _interopRequireDefault(require("../MenuSuggestionItem"));
var rawLabelOf = (0, _prop2["default"])('props.rawLabel');
var childrenOf = (0, _prop2["default"])('props.children');
var isMenuItemList = (0, _compose["default"])((0, _eq["default"])(_MenuItemList["default"].displayName), _componentUtils.typeOf);
var isMenuItemGroup = (0, _compose["default"])((0, _eq["default"])(_MenuItemGroup["default"].displayName), _componentUtils.typeOf);
var isSuggestionMenuItem = (0, _compose["default"])((0, _eq["default"])(_MenuSuggestionItem["default"].displayName), _componentUtils.typeOf);
var isMenuItem = exports.isMenuItem = (0, _compose["default"])((0, _eq["default"])(_MenuItem["default"].displayName), _componentUtils.typeOf);
function getFlattenItems(children) {
  return (0, _compose["default"])(_compact["default"], _flatten["default"], (0, _map["default"])(function (child) {
    var _child$props;
    if (isMenuItem(child) || isSuggestionMenuItem(child)) {
      return child;
    }
    return (child === null || child === void 0 || (_child$props = child.props) === null || _child$props === void 0 ? void 0 : _child$props.children) && getFlattenItems(child.props.children);
  }), _componentUtils.childrenToArray)(children);
}
var getAllItemProps = exports.getAllItemProps = (0, _compose["default"])((0, _map["default"])((0, _prop2["default"])('props')), getFlattenItems);
var getAllItemValues = exports.getAllItemValues = (0, _compose["default"])((0, _map["default"])((0, _prop2["default"])('value')), getAllItemProps);
var labelFor = exports.labelFor = function labelFor(children) {
  return function (value) {
    var label = (0, _compose["default"])(function (child) {
      var _prop;
      return (_prop = (0, _prop2["default"])('props.rawLabel')(child)) !== null && _prop !== void 0 ? _prop : (0, _prop2["default"])('props.children')(child);
    }, (0, _find["default"])((0, _propEq["default"])('props.value', value)), getFlattenItems)(children);
    return typeof label === 'string' ? label : value;
  };
};
function filterMenuItems(searchText, children) {
  return (0, _compose["default"])((0, _filter["default"])(function (child) {
    return !isMenuItem(child) || new RegExp((0, _escapeRegExp["default"])(searchText), 'i').test(rawLabelOf(child));
  }), _componentUtils.childrenToArray)(children);
}
function filterMenuItemList(searchText, menuItemList) {
  var filteredChildren = filterMenuItems(searchText, childrenOf(menuItemList));
  return filteredChildren.length > 0 ? /*#__PURE__*/_react["default"].cloneElement(menuItemList, menuItemList.props, filteredChildren) : null;
}
function filterMenuItemGroup(searchText, menuItemGroup) {
  var filteredChildren = (0, _compose["default"])(_compact["default"],
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  (0, _map["default"])(filterByType(searchText)), _componentUtils.childrenToArray, childrenOf)(menuItemGroup);
  return filteredChildren.length > 0 ? /*#__PURE__*/_react["default"].cloneElement(menuItemGroup, menuItemGroup.props, filteredChildren) : null;
}
var filterByType = function filterByType(searchText) {
  return function (child) {
    if (!searchText) return child;
    if (isMenuItemList(child)) return filterMenuItemList(searchText, child);
    if (isMenuItemGroup(child)) return filterMenuItemGroup(searchText, child);
    return child;
  };
};
function filterItems(searchText, children) {
  return children && _react["default"].Children.map(children, filterByType(searchText));
}